import { actionGenerator, IReduxAction } from '../../utils/actions';

/**
 * @deprecated Не используется
 */
export const SELECT_PLACING_PERIOD = 'PUBLISH_TERMS :: SELECT_PLACING_PERIOD';

/**
 * @deprecated  Не используется
 */
export type TSelectPlacingPeriodAction = IReduxAction<typeof SELECT_PLACING_PERIOD, number>;

/**
 * @deprecated  Не используется
 */
export const selectPlacingPeriod = actionGenerator<typeof SELECT_PLACING_PERIOD, number>(SELECT_PLACING_PERIOD);
